import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dropdownMenuContentDefaultVariants = {}
const dropdownMenuContentCompoundVariants = []

const dropdownMenuContentSlotNames = [
  [
    "content",
    "dropdown-menu__content"
  ],
  [
    "item",
    "dropdown-menu__item"
  ],
  [
    "label",
    "dropdown-menu__label"
  ],
  [
    "separator",
    "dropdown-menu__separator"
  ],
  [
    "indicator",
    "dropdown-menu__indicator"
  ],
  [
    "indicatorBorder",
    "dropdown-menu__indicatorBorder"
  ],
  [
    "indicatorDot",
    "dropdown-menu__indicatorDot"
  ],
  [
    "arrow",
    "dropdown-menu__arrow"
  ],
  [
    "radioButton",
    "dropdown-menu__radioButton"
  ]
]
const dropdownMenuContentSlotFns = /* @__PURE__ */ dropdownMenuContentSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dropdownMenuContentDefaultVariants, getSlotCompoundVariant(dropdownMenuContentCompoundVariants, slotName))])

const dropdownMenuContentFn = memo((props = {}) => {
  return Object.fromEntries(dropdownMenuContentSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dropdownMenuContentVariantKeys = []
const getVariantProps = (variants) => ({ ...dropdownMenuContentDefaultVariants, ...compact(variants) })

export const dropdownMenuContent = /* @__PURE__ */ Object.assign(dropdownMenuContentFn, {
  __recipe__: false,
  __name__: 'dropdownMenuContent',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: dropdownMenuContentVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, dropdownMenuContentVariantKeys)
  },
  getVariantProps
})